import { getTrackingCookieSafe } from '@porterin/booking-flow/src/order-review/view/helpers/CookieHelper';
import {
  publishEventParameter,
  publishGa4Events,
} from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import { useCitySelectedContext } from '../../contexts/city-context/CityContext';
import { GA_CATEGORY_CARD_ACTION } from '../../shared/core/constants/GAEventsConstants';
import styles from '../styles/common/CategoryCard.module.scss';

const COMPARE_EVENT_LABEL = 'Compare Event';

export function serviceShortName(service: string): string {
  const normalized = service.toLowerCase();
  if (normalized === 'truck' || normalized === 'trucks') return 'truck';
  if (normalized === 'two wheeler' || normalized === 'two wheelers')
    return '2w';
  if (
    normalized === 'packers and movers' ||
    normalized === 'pnm' ||
    normalized === 'packers & movers'
  ) {
    return 'pnm';
  }
  if (
    normalized === 'courier service' ||
    normalized === 'courier services' ||
    normalized === 'courier' ||
    normalized === 'intercity' ||
    normalized === 'all india parcel' ||
    normalized === 'intercity courier service'
  ) {
    return 'courier';
  }
  return normalized;
}

interface Service {
  text: string;
  image: { path: string; alt_text: string };
  link: string;
}

interface CategoryCardCmpProps {
  service: Service;
  is_redirecting: boolean;
  setIsRedirecting: (fn: (prev: boolean) => boolean) => void;
}

function CategoryCardCmp({
  service,
  is_redirecting,
  setIsRedirecting,
}: CategoryCardCmpProps): React.ReactElement {
  const citySelectedContext = useCitySelectedContext();

  const elementId = `category-card-${service.text.replace(/\s+/g, '')}`;

  return (
    <Link
      href={service.link + citySelectedContext.query_params}
      target="_parent"
    >
      <div
        className={styles['category-card']}
        id={elementId}
        onClick={() => {
          if (!is_redirecting) {
            setIsRedirecting(() => true);
            publishGa4Events(
              citySelectedContext.category,
              service.text + GA_CATEGORY_CARD_ACTION,
              service.link,
            );
            publishGa4Events(
              citySelectedContext.category,
              `fe_home_${serviceShortName(service.text)}_tap`,
              service.link,
            );
            publishEventParameter(COMPARE_EVENT_LABEL, {
              web_tracking_id: getTrackingCookieSafe(),
              service_type: service.text,
              service_card_id: uuidv4(),
            });
          }
        }}
      >
        <div className={styles['icon-bg']}>
          <Image
            src={service.image.path}
            width={200}
            height={200}
            alt={service.image.alt_text}
            quality={100}
          />
        </div>
        <div className={styles['text']}>{service.text}</div>
      </div>
    </Link>
  );
}

export default CategoryCardCmp;
